import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import carBikeImage from "../../assets/car-bike.png";
import styles from "./VehicleReRegistration.module.css";

function VehicleReRegistration() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: "",
    vehicleNumber: "",
    phoneNumber: "",
  });
  const [files, setFiles] = useState([]);
  const [showPopup, setShowPopup] = useState(false);
  const [error, setError] = useState(null);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleFileChange = (e) => {
    const selectedFiles = Array.from(e.target.files);
    setFiles((prevFiles) => [...prevFiles, ...selectedFiles]);
  };

  const handleSubmit = async () => {
    const token = localStorage.getItem("token");
    const vehicle_id = localStorage.getItem("vehicle_id");

    if (!token) {
      setError("Authentication token missing. Please log in again.");
      return;
    }
    if (!vehicle_id) {
      setError("Vaahan ID missing. Please select a vaahan.");
      return;
    }
    if (files.length === 0) {
      setError("Please upload at least one document.");
      return;
    }

    const headers = new Headers();
    headers.append("Authorization", `Bearer ${token}`);

    const form = new FormData();
    form.append("service_type", "ReregistrationVehicle");
    form.append("vehicle_id", vehicle_id);
    form.append(
      "additional_info",
      JSON.stringify({ policy_number: "POL123456" })
    );
    files.forEach((file) => {
      form.append("documents", file);
    });

    try {
      const response = await fetch(
        "https://api.rtoxpert.com/api/service-requests",
        {
          method: "POST",
          headers,
          body: form,
          redirect: "follow",
        }
      );

      if (response.ok) {
        setShowPopup(true);
        setError(null);
        setTimeout(() => {
          setShowPopup(false);
          navigate("/profile");
        }, 2000);
      } else {
        const errorText = await response.text();
        setError("Submission failed: " + errorText);
      }
    } catch (err) {
      console.error(err);
      setError("Error occurred: " + err.message);
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.formSection}>
        {error && <div className={styles.errorMessage}>{error}</div>}
        <div className={styles.inputGroup}>
          <label>Name</label>
          <input
            name="name"
            type="text"
            placeholder="Name"
            className={styles.inputField}
            value={formData.name}
            onChange={handleChange}
          />
        </div>

        <div className={styles.inputGroup}>
          <label>Vaahan Number</label>
          <input
            name="vehicleNumber"
            type="text"
            placeholder="Vaahan Number"
            className={styles.inputField}
            value={formData.vehicleNumber}
            onChange={handleChange}
          />
        </div>

        <div className={styles.inputGroup}>
          <label>Phone Number</label>
          <input
            name="phoneNumber"
            type="text"
            placeholder="Phone Number"
            className={styles.inputField}
            value={formData.phoneNumber}
            onChange={handleChange}
          />
        </div>

        <div className={styles.fileInputGroup}>
          <label>Upload Documents</label>
          <div className={styles.fileUploadWrapper}>
            <label className={styles.fileUploadLabel}>
              Choose File(s)
              <input
                type="file"
                className={styles.fileInput}
                onChange={handleFileChange}
                multiple
              />
            </label>
          </div>

          {files.length > 0 && (
            <ul className={styles.uploadedFiles}>
              {files.map((file, index) => (
                <li key={index} className={styles.fileItem}>
                  📄 {file.name}
                </li>
              ))}
            </ul>
          )}
        </div>

        {/* <div className={styles.documentsSection}>
          <div className={styles.documentCard}>
            <div className={styles.iconContainer}>
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className={styles.icon}
              >
                <path
                  d="M19 13H13V19H11V13H5V11H11V5H13V11H19V13Z"
                  fill="#5F45B8"
                />
              </svg>
            </div>
            <div className={styles.docText}>
              <span>Original RC</span>
            </div>
          </div>

          <div className={styles.documentCard}>
            <div className={styles.iconContainer}>
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className={styles.icon}
              >
                <path
                  d="M19 13H13V19H11V13H5V11H11V5H13V11H19V13Z"
                  fill="#5F45B8"
                />
              </svg>
            </div>
            <div className={styles.docText}>
              <span>Chassis Impression on form 25</span>
            </div>
          </div>
        </div> */}

        <button className={styles.submitButton} onClick={handleSubmit}>
          Submit
        </button>

        {showPopup && (
          <div className={styles.successMessage}>
            Agent will reach out to you.
          </div>
        )}
      </div>

      <div className={styles.imageSection}>
        <img
          src={carBikeImage}
          alt="Vaahan images showing SUV and motorcycle"
          className={styles.vehicleImage}
        />
      </div>
    </div>
  );
}

export default VehicleReRegistration;